// Vendor imports
const _ = require('lodash')
// Client lib imports
const globalPageContext = require('client/lib/business-events/page-context')
const { openWindow } = require('client/lib/window')
// Sibling imports
const { normalizeInternalHref } = require('./utils')

// Action types

const NAVIGATE = 'ROUTER_NAVIGATE'
const SET_LOCATION = 'SET_LOCATION'
// Middleware commands
const CONFIGURE_HISTORY = 'ROUTER_CONFIGURE_HISTORY'
const GO_BACK = 'ROUTER_GO_BACK'
const GO_FORWARD = 'ROUTER_GO_FORWARD'
const PUSH = 'ROUTER_PUSH'
const REPLACE = 'ROUTER_REPLACE'
const RELOAD = 'ROUTER_RELOAD'

// Action creators

function setLocation({ location, action }) {
  return {
    type: SET_LOCATION,
    payload: { location, action }
  }
}

function configureHistory(history) {
  return {
    type: CONFIGURE_HISTORY,
    payload: history
  }
}

function goBack() {
  return {
    type: GO_BACK
  }
}

function goForward() {
  return {
    type: GO_FORWARD
  }
}

function push({ path, state }) {
  return {
    type: PUSH,
    payload: { path, state }
  }
}

function replace({ path, state }) {
  return {
    type: REPLACE,
    payload: { path, state }
  }
}

function reload() {
  return {
    type: RELOAD
  }
}

// Action dispatchers

function navigate(arg) {
  if (_.isString(arg)) {
    // Maintain compatibility with string argument form
    return navigate({ href: arg })
  }
  if (arg.currentTarget instanceof HTMLAnchorElement) {
    // Support click event on anchor tag
    arg.preventDefault()
    return navigate({
      event: arg,
      href: arg.currentTarget.getAttribute('href')
    })
  }
  const { event, href, pageContext } = arg
  const normalizedHref = normalizeInternalHref(href)
  return function () {
    globalPageContext.persistPageContext(pageContext)
    if (event && event.metaKey) {
      openWindow(normalizedHref)
    } else {
      // https://app.asana.com/0/102902769366319/681203866231475/f
      window.location.assign(normalizedHref)
    }
  }
}

// Exports

module.exports = {
  CONFIGURE_HISTORY,
  GO_BACK,
  GO_FORWARD,
  NAVIGATE,
  PUSH,
  RELOAD,
  REPLACE,
  SET_LOCATION,
  configureHistory,
  goBack,
  goForward,
  navigate,
  push,
  reload,
  replace,
  setLocation
}
